<template>
	<main id="container" class="page-container information bg-wave3">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="할인혜택" />
				</div>
			</div>
		</div>
		<div class="page-content">
			<div class="container">
				<div class="info-content-img">
						<img src="@/assets/img/main/dhfesta_productInfo_0415.png" alt="동행축제 안내" style="width: 100%; max-width: 1000px; margin: 0 auto; display: block;" />
					</div>
				<!-- <div class="information-period">
					<div class="period-desc">
						<span class="period-desc-title">행사기간</span>
						<span class="period-desc-date">2024년 12월 1일(일) ~ 12월 28일(토)</span>
					</div>
					<div class="period-icon">
						<img src="@/assets/img/information/info-calendar-icon.png" alt="" />
					</div>
				</div> -->
			</div>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'ProductInformation',
	components: { PageHeader },
	data: () => ({}),
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	methods: {},
};
</script>
